module.exports = __webpack_public_path__ + "img/section2LeftModelM.c5ac4143.webp";